import type { Utility } from "@cs2/contracts/domain";
import { formatCountdown } from "../lib/countdown.js";
import { utilityColor } from "../lib/map-style.js";
import { UtilityIcon } from "./UtilityIcon.js";

/**
 * Eine Utility-Zeile in einer Schrittliste — Quickview (nur lesend, eingefärbt)
 * und Editor-Inspektor (auswählbar, Farbe kommt aus dem `active`-Zustand der
 * CSS-Klasse) teilen sich Markup und Daten, der Listen-Container (`ul`) bleibt
 * beim Aufrufer, weil dessen Klasse Layout/Größe je Kontext bestimmt.
 */
export function UtilityStepChip({
  utility,
  offsetSeconds,
  selected,
  colorize,
  onSelect,
}: {
  utility: Utility;
  offsetSeconds: number | null | undefined;
  selected?: boolean;
  colorize?: boolean;
  onSelect: () => void;
}) {
  return (
    <li>
      <button
        type="button"
        className={selected ? "active" : ""}
        style={colorize ? { color: utilityColor(utility.type) } : undefined}
        onClick={(event) => {
          event.stopPropagation();
          onSelect();
        }}
      >
        <UtilityIcon type={utility.type} />
        <b>{utility.type}</b>
        <small>{utility.targetCallout}</small>
        <em>{formatCountdown(offsetSeconds)}</em>
      </button>
    </li>
  );
}
